import * as React from "react";

const HomeIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      stroke="#272727"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m2.667 10.667 12.976-6.488a.8.8 0 0 1 .714 0l12.976 6.488m-2.666 4v10.666A2.667 2.667 0 0 1 24 28H8a2.667 2.667 0 0 1-2.667-2.667V14.667"
    ></path>
  </svg>
);

export default HomeIcon;
